export const colors = {
  lightGray: '#e6e6e6',
  midGray: '#b5aca9',
  midLtGray: '#999',
  midDkGray: '#666',
  darkGray: '#444',
  darkOrange: '#B86431'
}